/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nrl_Updateerror2Inputs */

const en_coinvestments_nrl_updateerror2 = /** @type {(inputs: Coinvestments_Nrl_Updateerror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update Non-Release Letter. Please try again.`)
};

/**
* | output |
* | --- |
* | "Failed to update Non-Release Letter. Please try again." |
*
* @param {Coinvestments_Nrl_Updateerror2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nrl_updateerror2 = /** @type {((inputs?: Coinvestments_Nrl_Updateerror2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nrl_Updateerror2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nrl_updateerror2(inputs)
});
export { coinvestments_nrl_updateerror2 as "coInvestments_nrl_updateError" }